import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { CopyrightFeeTooltip } from '../components/CopyrightFeeTooltip';
import { Image } from '../components/Image';
import { PriceRow } from '../components/PriceRow';
import { RemoveAction } from '../components/RemoveAction';
import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { ImageData, Price } from '../model';
import { CellTitle, Separator, UpsellEntryListItem } from './entries.styles';

type UpsellEntryProps = {
    name: string;
    image: ImageData;
    price: Price;
    copyrightFee: Price;
    onRemove?: () => void;
    isLoading?: boolean;
    isDisabled?: boolean;
};

export const UpsellEntry: FC<UpsellEntryProps> = ({
    copyrightFee,
    image,
    isLoading,
    isDisabled,
    name,
    onRemove,
    price,
}) => {
    const { t } = useTranslations();

    return (
        <UpsellEntryListItem data-test={ORDER_CART_ENTRY_ID.UPSELL} aria-label={name}>
            <Image url={image.url} alt={image.alt} />
            <CellTitle data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_UPSELL}>{name}</CellTitle>
            <Separator />
            <PriceRow
                term={t['order_cart.entry_upsell.price_label']}
                price={price}
                dataTest={ORDER_CART_TEST_ID.PRICE_UPSELL}
            />
            <PriceRow
                term={<CopyrightFeeTooltip />}
                price={copyrightFee}
                dataTest={ORDER_CART_TEST_ID.PRICE_UPSELL_COPYRIGHT_FEE}
            />
            <RemoveAction onRemove={onRemove} isLoading={isLoading} isDisabled={isDisabled} />
        </UpsellEntryListItem>
    );
};
